<template>
    <AuthHeader @hiddenContent="hideContent = true" @showContent="hideContent = false"/>
    <div :class="{ 'hidden' : hideContent }">
        <slot></slot>
        <Footer :auth="true" />
    </div>
</template>

<script>
import ApplicationLogo from '@/Components/ApplicationLogo.vue';
import NavLink from '@/Components/NavLink.vue';
import ButtonLink from '@/Components/ButtonLink.vue';
import { Link } from '@inertiajs/inertia-vue3';
import Footer from '@/Components/Footer.vue';
import AuthHeader from '@/Components/UI/Nav/AuthHeader.vue';

export default {
    components: {
        ApplicationLogo,
        ButtonLink,
        NavLink,
        Link,
        Footer,
        AuthHeader
    },
    props: {
        hideContent: Boolean,
    },
    data() {
        return {
            navigationOpenState: false
        }
    },

    computed: {
        navigationClasses(){
            return this.navigationOpenState ? 'left-0' : 'left-[-270px]'
        }
    },
}
</script>
